import React from "react";
import BarLoader from "react-spinners/BarLoader";
import "./loader.scss";

export default function Loader({ name }) {
  return (
    <div className="loader-hierarchy-module">
      <BarLoader
        className="loader"
        color={"#e2136e"}
        size={50}
        loading={true}
      />
      <p>Fetching {name ? name : ""} data</p>
    </div>
  );
}
